var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6004 17C30.6004 20.607 29.1675 24.0662 26.617 26.6167C24.0665 29.1672 20.6073 30.6 17.0004 30.6C13.3934 30.6 9.93423 29.1672 7.38374 26.6167C4.83324 24.0662 3.40039 20.607 3.40039 17C3.40039 13.3931 4.83324 9.93387 7.38374 7.38337C9.93423 4.83288 13.3934 3.40002 17.0004 3.40002C20.6073 3.40002 24.0665 4.83288 26.617 7.38337C29.1675 9.93387 30.6004 13.3931 30.6004 17ZM20.4004 11.9C20.4004 12.8018 20.0422 13.6666 19.4046 14.3042C18.7669 14.9418 17.9021 15.3 17.0004 15.3C16.0987 15.3 15.2339 14.9418 14.5962 14.3042C13.9586 13.6666 13.6004 12.8018 13.6004 11.9C13.6004 10.9983 13.9586 10.1335 14.5962 9.49586C15.2339 8.85824 16.0987 8.50002 17.0004 8.50002C17.9021 8.50002 18.7669 8.85824 19.4046 9.49586C20.0422 10.1335 20.4004 10.9983 20.4004 11.9ZM17.0004 18.7C15.3728 18.6997 13.7794 19.1667 12.4094 20.0454C11.0394 20.9242 9.95056 22.1778 9.27219 23.6572C10.2287 24.77 11.4147 25.6628 12.7486 26.2743C14.0825 26.8858 15.533 27.2016 17.0004 27.2C18.4678 27.2016 19.9182 26.8858 21.2522 26.2743C22.5861 25.6628 23.772 24.77 24.7286 23.6572C24.0502 22.1778 22.9613 20.9242 21.5914 20.0454C20.2214 19.1667 18.628 18.6997 17.0004 18.7Z",
    fill: "#3F3F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.b080e3137e25865a8b33bd9b029dc132.svg";
export { ForwardRef as ReactComponent };